import { createFileRoute, redirect } from "@tanstack/react-router";
import { getStoredUserRole } from "@/shared/infrastructure/auth/token-storage";
import { AdminFeatureFlagsPage } from "@/modules/admin/presentation/pages/AdminFeatureFlagsPage";
import { UserRole } from "@/modules/auth/domain/entities";

export const Route = createFileRoute("/_authenticated/admin-feature-flags")({
  beforeLoad: () => {
    if (getStoredUserRole() !== UserRole.Admin) {
      throw redirect({ to: "/" });
    }
  },
  component: AdminFeatureFlagsPage,
});
